import React from 'react';
import { Redirect } from 'react-router-dom';
import { Auth } from 'aws-amplify';

const Logout = () => {
  localStorage.clear();
  Auth.signOut();
  return <Redirect to={{ pathname: '/' }} />;
};
export default Logout;
